module.exports = __webpack_public_path__ + "img/loading.aa8fe56f.gif";